module.exports = __webpack_public_path__ + "img/service_image7.072742b8.jpg";